// extracted by mini-css-extract-plugin
export default {"item":"simpleReportShimmer_item__EJ1HC","item_number":"simpleReportShimmer_item_number__OBzQ6"};